export default "__VITE_ASSET__DRW2qZ30__"